import { FC } from 'react'

import clsx from 'clsx'

import useCountdownTimer from 'shared/hooks/use-countdown-timer'

import s from './styles.module.scss'

interface TimerProps {
  expiredDate: string
}

export const OrderDetailTime: FC<TimerProps> = ({ expiredDate }) => {
  const timeLeft = useCountdownTimer(expiredDate)
  const formattedTime = `${timeLeft.hours}:${timeLeft.minutes}:${timeLeft.seconds}`

  return <div className={clsx(s.timer, 'regular-14')}>{formattedTime}</div>
}
